import axios from "axios";
import {
	ACCESS_TOKEN,
	CHANGE_COMPANY_ACTIVE_STATUS_URL,
	CHANGE_VERIFICATION_STATUS_COMPANY_URL,
	DELETE_COMPANY_URL,
	GET_COMPANY_BY_ID,
	GET_COMPANY_LIST,
	POST_COMPANY_URL,
	UPDATE_COMPANY_URL,
} from "../helpers/Constant";

export default class CompanyService {
	static getCompanyList(params) {
		return axios.get(GET_COMPANY_LIST, {
			...CompanyService.getAuthHeader(),
			params,
		});
	}

	static getCompanyById(id) {
		return axios.get(
			`${GET_COMPANY_BY_ID}/${id}`,
			CompanyService.getAuthHeader(),
		);
	}

	static addCompany(data) {
		return axios.post(
			POST_COMPANY_URL,
			data,
			CompanyService.getAuthHeader(),
		);
	}

	static editCompany(id, data) {
		return axios.put(
			`${UPDATE_COMPANY_URL}/${id}`,
			data,
			CompanyService.getAuthHeader(),
		);
	}

	static changeVerificationStatusCompany(id, verified) {
		return axios.put(
			`${CHANGE_VERIFICATION_STATUS_COMPANY_URL}/${id}`,
			null,
			{
				...CompanyService.getAuthHeader(),
				params: { verified },
			},
		);
	}

	static deleteCompany(id) {
		return axios.delete(
			`${DELETE_COMPANY_URL}/${id}`,
			CompanyService.getAuthHeader(),
		);
	}

	static changeCompanyActiveStatus(id, active) {
		return axios.put(`${CHANGE_COMPANY_ACTIVE_STATUS_URL}/${id}`, null, {
			...CompanyService.getAuthHeader(),
			params: { active },
		});
	}

	static getAuthHeader = () => {
		const accessToken = localStorage.getItem(ACCESS_TOKEN);
		return { headers: { "x-auth-token": accessToken } };
	};
}
